module.exports = __webpack_public_path__ + "static/media/design-suede.7d02ee78.svg";